import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormEventRegistrationService } from 'src/app/service/form-event-registration.service';
import { LoadingService } from 'src/app/service/loading.service';
import { TimerService } from 'src/app/service/timer.service';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {

  @Input() uuid: string = '';
  @Input() clock!: number;  // Countdown duration in seconds
  @Input() clockDelay!: number; // Warning time before expiration
  @Input() refresh!: () => void; // Refresh function from parent

  isAssumingProfile = false;
  modalOpen: boolean = false;

  remainingMinutes: string = '00';
  remainingSeconds: string = '00';

  private expirationTime: number = 0;
  private expirationTimeoutId: any;
  private countdownIntervalId: any;

  isTimerVisible = false;

  constructor(
    private formEventRegistrationService: FormEventRegistrationService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {

    setTimeout(() => {
      this.isAssumingProfile = document.getElementById("assumed-user-banner") !== null;
    }, 100);

    if (this.clock > 0) {
      this.startCountdown();
    }
  }

  private startCountdown(): void {

    this.expirationTime = Date.now() + this.clock * 1000; // Store the expiration timestamp

    this.updateCountdown(); // Update immediately

    // Start countdown interval to update every second
    this.countdownIntervalId = setInterval(() => this.updateCountdown(), 1000);

    // Set timeout for expiration event
    this.expirationTimeoutId = setTimeout(() => {
      this.modalOpen = true;
      this.stopCountdown();
    }, this.clock * 1000);
  }

  private updateCountdown(): void {

    const timeRemaining = Math.max(0, Math.floor((this.expirationTime - Date.now()) / 1000));

    this.remainingMinutes = Math.floor(timeRemaining / 60).toString().padStart(2, '0');
    this.remainingSeconds = (timeRemaining % 60).toString().padStart(2, '0');

    if (timeRemaining === 0) {
      this.stopCountdown();
      this.modalOpen = true;
    }
  }

  isExpiringSoon(): boolean {
    return (this.expirationTime - Date.now()) <= this.clockDelay * 1000;
  }

  onClose(): void {
    this.modalOpen = false;
  }

  onRefresh(): void {
    this.loadingService.setLoading(true);

    this.formEventRegistrationService.refreshReservations(this.uuid).subscribe({
      next: () => {
        this.refresh();
        this.modalOpen = false;
        this.startCountdown();
      },
      error: () => {
        console.error('Error refreshing reservations.');
      }
    });
  }

  private stopCountdown(): void {
    clearInterval(this.countdownIntervalId);
    clearTimeout(this.expirationTimeoutId);
  }

  ngOnDestroy() {
    this.stopCountdown();
  }
}
